import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './QuestionLayoutContainer.scss';
import { questionLayoutPropType } from '../../../../config/richTextConfig/questionLayout';

const QuestionLayoutContainer = ({ layout, className, children }) => (
  <div
    className={cx(styles.container, className, styles[`${layout}Container`])}
  >
    {children}
  </div>
);

QuestionLayoutContainer.propTypes = {
  layout: questionLayoutPropType,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default QuestionLayoutContainer;
